import React from "react"
import classes from "utils/classes"

import styles from "./Textarea.module.scss"

const Textarea = ({ id, value, error, placeholder, onChange }) => {
  return (
    <div>
      <div
        className={classes(styles.wrapper, value.length > 0 && styles.filled)}
      >
        <textarea
          id={id}
          value={value}
          onChange={evt => onChange(evt.target.value)}
        />
        <label htmlFor={id} className={styles.placeholder}>
          {placeholder}
        </label>
      </div>
      {error && <div className={styles.errorMsg}>{error}</div>}
    </div>
  )
}

export default Textarea
